import { BasementComponent } from './BasementComponent';

export default BasementComponent;